// const basePath = "http://localhost:8081/api"
const basePath = "https://web-personal-node.herokuapp.com/api"
const apiVersion = "v1"

export const urlBase = `${basePath}/${apiVersion}`
